import { combineReducers } from 'redux';
import { recommend } from './news/recommend.reducer';
import { comment } from './news/comment.reducer';
import { common, pageState } from './news/common.reducer';
import { downloadBar } from './news/downloadBar.reducer';
import { userInfo } from './news/userInfo.reducer';
import { article } from './news/article.reducer';
import { dialog } from './news/dialog.reducer';
import { smp } from './news/smp.reducer';
import { search } from './news/search.reducer';
import { videoInfo } from './video/videoInfo.reducer';
import { recommendVideos } from './video/recommand.reducer';
import { videoCommon } from './video/videoCommon.reducer';
import { shareCommon } from './common/share.reducer';
import { shortContents } from './shortContent/content.reducer';
import { commentNew } from './common/commentNew.reducer';
import { recommendPop } from './news/recommendPop.reducer';
import { secSharePop } from './common/secSharePop.reducer';
import { clipboard } from './eCommerceFission/clipboard.reducer';
import { activity, commodity, eCommerceDialog } from './eCommerceFission/activity.reducer';
const rootReducer = combineReducers({
  recommend,
  comment,
  common,
  pageState,
  downloadBar,
  userInfo,
  article,
  dialog,
  smp,
  search,
  videoInfo,
  recommendVideos,
  videoCommon,
  shareCommon,
  shortContents,
  commentNew,
  recommendPop,
  secSharePop,
  clipboard,
  activity,
  commodity,
  eCommerceDialog,
});

export default rootReducer;
